import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { removeBaseEndpoint } from "@/helpers/Helpers";
import { useDrop } from "@/hooks/useDrop";
import Link from "next/link";
import ChatItemHrefButtons from "../ChatItemHrefButtons";
import { SingleWaveDropPosition } from "../drop/SingleWaveDropPosition";
import { SingleWaveDropVotes } from "../drop/SingleWaveDropVotes";
export default function DropItemChat(t0) {
  const $ = _c(46);
  const {
    href,
    dropId
  } = t0;
  const {
    isMemesSubmission
  } = useSeizeSettings();
  let t1;
  if ($[0] !== dropId) {
    t1 = {
      dropId
    };
    $[0] = dropId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    drop
  } = useDrop(t1);
  let t2;
  if ($[2] !== href) {
    t2 = removeBaseEndpoint(href);
    $[2] = href;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const relativeLink = t2;
  let t3;
  if ($[4] !== drop?.parts) {
    t3 = drop?.parts?.at(0)?.media?.at(0);
    $[4] = drop?.parts;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const artworkMedia = t3;
  let t4;
  if ($[6] !== drop?.metadata || $[7] !== drop?.title) {
    t4 = drop?.metadata?.find(_temp)?.data_value || drop?.title;
    $[6] = drop?.metadata;
    $[7] = drop?.title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const title = t4;
  const canOpenDrop = drop?.drop_type !== ApiDropType.Chat;
  if (!drop) {
    let t5;
    if ($[9] !== href || $[10] !== relativeLink) {
      t5 = <Link href={relativeLink}>{href}</Link>;
      $[9] = href;
      $[10] = relativeLink;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== artworkMedia?.mime_type || $[13] !== drop || $[14] !== isMemesSubmission) {
    t5 = isMemesSubmission(drop) && <MediaTypeBadge mimeType={artworkMedia?.mime_type} dropId={drop.id} size="sm" />;
    $[12] = artworkMedia?.mime_type;
    $[13] = drop;
    $[14] = isMemesSubmission;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== canOpenDrop || $[17] !== relativeLink || $[18] !== title) {
    t6 = canOpenDrop ? <Link className="tw-no-underline" href={relativeLink}>{title}</Link> : title;
    $[16] = canOpenDrop;
    $[17] = relativeLink;
    $[18] = title;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t6) {
    t7 = <h3 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-100 sm:tw-text-lg">{t6}</h3>;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t5 || $[23] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2">{t5}{t7}</div>;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== drop) {
    t9 = drop?.drop_type === ApiDropType.Participatory && <SingleWaveDropPosition rank={drop.rank} />;
    $[25] = drop;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <div className="tw-flex tw-flex-row tw-items-center tw-gap-x-4">{t8}{t9}</div>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== drop || $[31] !== relativeLink) {
    t11 = drop && <><span className="tw-leading-0 -tw-mt-1 tw-mb-0 tw-text-[11px] tw-text-iron-500 tw-no-underline tw-transition tw-duration-300 tw-ease-out"><Link className="tw-no-underline" href={relativeLink}>{drop.wave.name}</Link></span><SingleWaveDropVotes drop={drop} /></>;
    $[30] = drop;
    $[31] = relativeLink;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== artworkMedia || $[34] !== drop) {
    t12 = artworkMedia && <div className="tw-mt-4 tw-flex tw-h-96 tw-justify-center"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={drop.drop_type === ApiDropType.Participatory || drop.drop_type === ApiDropType.Winner} /></div>;
    $[33] = artworkMedia;
    $[34] = drop;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t12) {
    t13 = <div className="tw-min-w-0 tw-flex-1"><div className="tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-p-4">{t10}{t11}{t12}</div></div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== href || $[41] !== relativeLink) {
    t14 = <ChatItemHrefButtons href={href} relativeHref={relativeLink} />;
    $[40] = href;
    $[41] = relativeLink;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t13 || $[44] !== t14) {
    t15 = <div className="tw-flex tw-w-full tw-items-stretch tw-gap-x-1">{t13}{t14}</div>;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
}
function _temp(m) {
  return m.data_key === "title";
}